import React, { Fragment } from "react";
import { InspectorControls } from "@wordpress/block-editor";
import { PanelBody } from "@wordpress/components";
import { addFilter } from "@wordpress/hooks";
import { createHigherOrderComponent } from "@wordpress/compose";
import {
    commonAttributes,
    HoverBarControls,
    getHoverBarStyle,
} from "./components/imageComponents";

// Dodajemy nowe atrybuty do bloku Featured Image
const addFeaturedImageAttributes = (settings) => {
    if (settings.name !== "core/post-featured-image") {
        return settings;
    }

    return {
        ...settings,
        attributes: {
            ...settings.attributes,
            ...commonAttributes,
        },
    };
};

// Dodajemy kontrolki do panelu inspekcji
const withInspectorControls = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        if (props.name !== "core/post-featured-image") {
            return <BlockEdit {...props} />;
        }

        return (
            <Fragment>
                <BlockEdit {...props} />
                <InspectorControls>
                    <PanelBody title="Hover bar" initialOpen={false}>
                        <HoverBarControls
                            attributes={props.attributes}
                            setAttributes={props.setAttributes}
                        />
                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, "withInspectorControls");

// Modyfikujemy wygląd bloku
const modifyFeaturedImageBlock = createHigherOrderComponent(
    (BlockListBlock) => {
        return (props) => {
            if (props.name !== "core/post-featured-image") {
                return <BlockListBlock {...props} />;
            }

            const { attributes, clientId } = props;
            const { showHoverBar } = attributes;
            const { key, ...restProps } = props;

            return (
                <div key={clientId || key} className="wp-block-post-image">
                    <BlockListBlock {...restProps} />
                    {showHoverBar && (
                        <div
                            key={`hover-bar-${clientId}`}
                            className={`hover-bar ${attributes.animation}`}
                            style={getHoverBarStyle(attributes)}
                        />
                    )}
                </div>
            );
        };
    },
    "modifyFeaturedImageBlock"
);

// Rejestrujemy filtry
addFilter(
    "blocks.registerBlockType",
    "kamikaze/featured-image-hover-attributes",
    addFeaturedImageAttributes
);

addFilter(
    "editor.BlockEdit",
    "kamikaze/featured-image-hover-controls",
    withInspectorControls
);

addFilter(
    "editor.BlockListBlock",
    "kamikaze/featured-image-hover-display",
    modifyFeaturedImageBlock
);
